// extracted by mini-css-extract-plugin
module.exports = {"section-header":"f6c6b","sectionHeader":"f6c6b","container":"_10428","compact":"e51ad","spinner":"_3bb69","section":"_144d4","jobs":"a4ee5"};